export enum Platform {
    Appwrite = 'appwrite',
    Imagine = 'imagine',
}